export default function () {
  return useState('app-overlay', () => false);
}
